import { connect } from 'react-redux';
import withAB from '../../../config/ab/withAB';
import { PINA_PROFILE_CHECK_INSURANCE_MODAL } from '../../../config/ab/experiments';
import { shouldShowCheckInsuranceModal } from '../../../config/ab/selector';
import { CheckInsuranceModalView } from './CheckInsuranceModalView';
import {
    trackClickCheckMyInsurance,
    trackClickCloseCheckInsuranceModal,
    trackShowCheckInsuranceModal,
} from './eventTrackingActions';
import {
    isCheckInsuranceModalAlreadyShownInCurrentSession,
    markCheckInsuranceModalShownInCurrentSession,
} from './utils';

const mapStateToProps = state => {
    return {
        showModal: shouldShowCheckInsuranceModal(state),
    };
};

const mapDispatchToProps = ({
    trackClickCheckMyInsurance,
    trackClickCloseCheckInsuranceModal,
    trackShowCheckInsuranceModal,
});

const CheckInsuranceModal = withAB(PINA_PROFILE_CHECK_INSURANCE_MODAL)(
    connect(mapStateToProps, mapDispatchToProps)(CheckInsuranceModalView)
);

export {
    CheckInsuranceModal as default,
    CheckInsuranceModal,
    isCheckInsuranceModalAlreadyShownInCurrentSession,
    markCheckInsuranceModalShownInCurrentSession,
};
